import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
    Button,
} from "@material-tailwind/react";
import { BiSolidTimeFive } from "react-icons/bi";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { GoNumber } from "react-icons/go";
import axios from "axios";
import { useEffect, useState } from "react";
import { ADMIN_API } from "../../functions";


const PreviousTestsCard = ({ stateManage, state, test, callback, date }) => {


    // let name, duration, totalQ, totalM, date;
    const [name, setName] = useState("");
    const [duration, setDuration] = useState("");
    const [totalQ, setTotalQ] = useState("");
    const [totalM, setTotalM] = useState("");
    const [enable, setEnable] = useState(false);


    const testLoader = async () => {
        const res = await axios.get(`${ADMIN_API}/getAllTest/${test.testId}`);
        const testdata = res.data.foundTest;
        // console.log(testdata, testdata.TestInfo.TestName);
        setName(testdata.TestInfo.TestName);
        setDuration(testdata.TestInfo.TestDuration);
        setTotalQ(testdata.QuestionSet.length);
        setTotalM(testdata.QuestionSet.length * 4);

        let dNow = new Date();
        let d = new Date(testdata.TestInfo.TestDelay);
        if (dNow < d) {
            console.log("Not Enabled");
            setEnable(false);
        }
        else {
            console.log("Enabled");
            setEnable(true);
        }
    }

    useEffect(() => {
        testLoader();
    }, []);


    return (
        <Card variant="gradient" className="w-full max-w-[20rem] p-3 py-5 h-max m-3 bg-bgBlue text-white">
            <CardHeader
                floated={false}
                color="transparent"
                className="m-0 mb-5  border-2 border-white/10 text-center rounded"
            >
                <Typography
                    variant="h4"
                    color="white"
                    className="mt-3 flex justify-center gap-1 text-2xl font-normal"
                >
                    {name}
                </Typography>
            </CardHeader>
            <CardBody className="p-0">
                <ul className="flex flex-col gap-2">
                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded-full border border-white/20 bg-white/20">
                            <BiSolidTimeFive className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">{duration} Minutes</Typography>
                    </li>


                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded-full border border-white/20 bg-white/20 ">
                            <BsFillQuestionCircleFill className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">Questions : {totalQ}</Typography>
                    </li>


                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded border border-white/20 bg-white/20 ">
                            <GoNumber className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">Total Marks : {totalM}</Typography>
                    </li>

                    <li className="flex items-center align-middle gap-4 border-b-2 border-[#ffffff8a]">
                        <span className="rounded border border-white/20 bg-white/20 ">
                            <GoNumber className="h-5 w-5" />
                        </span>
                        <Typography className="font-normal my-1">Date: {date}</Typography>
                    </li>
                </ul>
            </CardBody>
            <CardFooter className="p-0 flex justify-center m-3">
                <Button
                    size="lg"
                    color="white"
                    className={`text-bgBlue hover:scale-[1.02] focus:scale-[1.02] active:scale-100`}
                    onClick={() => {
                        callback(test)
                        stateManage(!state)
                    }}
                    disabled={!enable}
                >
                    View Analysis
                </Button>
            </CardFooter>
        </Card>
    );
}

export default PreviousTestsCard;